import { Button } from '@/components/ui/button';
import { addDays, format } from 'date-fns';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';

interface DateNavigationProps {
  selectedDate: string;
  onDateChange: (date: string) => void;
  disabled?: boolean;
}

export function DateNavigation({ selectedDate, onDateChange, disabled }: DateNavigationProps) {
  const handleDateChange = (days: number) => {
    const currentDate = new Date(`${selectedDate}T00:00:00`);
    const newDate = addDays(currentDate, days);
    onDateChange(format(newDate, 'yyyy-MM-dd'));
  };

  const handleToday = () => {
    onDateChange(format(new Date(), 'yyyy-MM-dd'));
  };

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="outline"
        size="sm"
        onClick={() => handleDateChange(-7)}
        disabled={disabled}
        title="Previous week"
      >
        <ChevronsLeft className="h-4 w-4" />
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={() => handleDateChange(-1)}
        disabled={disabled}
        title="Previous day"
      >
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <input
        type="date"
        value={selectedDate}
        onChange={(e) => onDateChange(e.target.value)}
        disabled={disabled}
        className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
      />
      <Button
        variant="outline"
        size="sm"
        onClick={() => handleDateChange(1)}
        disabled={disabled}
        title="Next day"
      >
        <ChevronRight className="h-4 w-4" />
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={() => handleDateChange(7)}
        disabled={disabled}
        title="Next week"
      >
        <ChevronsRight className="h-4 w-4" />
      </Button>
      <Button variant="outline" size="sm" onClick={handleToday} disabled={disabled}>
        Today
      </Button>
    </div>
  );
}
